import * as C from './consts';
import { boundApiReducer as api } from 'redux-upgrader';

export const info = api(C.GET_FRONT_PAGE, Object);
